import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StatusPagesService } from 'src/app/services/health-pages.service';

@Component({
    selector: 'app-root',
    templateUrl: './404.component.html',
      styleUrls: ['./404.component.scss']
})
export class NotFoundPageComponent implements OnInit {

    constructor(
        private statusPageService: StatusPagesService,
        private _route: ActivatedRoute,
        ) { }

    async ngOnInit() {
    }
}
